/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для страницы организаторов совместных покупок
   */
  app.SpView = app.View.extend({
    el: '#sp_page',
    
    events: {
      'click .sp-tab': 'toggleSpContent'
    },
    
    toggleSpContent: function (e) {
      var thisTab = $(e.currentTarget),
        thisTabData = thisTab.data('content');
      
      if (!thisTab.hasClass('selected')) {
        this.$('.sp-tab').removeClass('selected');
        thisTab.addClass('selected');
        
        this.$('.tab-content').hide();
        this.$('.' + thisTabData).show();
      }
    }
  });
})(jQuery);

}.call(window));